export enum CookiesEnum {
  JWT_HP = 'jwt_hp',
  JWT_S = 'JWT_S'
}
